import { Navigate } from 'react-router-dom';

import { useNavigateToRoute } from '@/components/navigation/useNavigateToRoute';
import { CreateEntityShortFormModal } from '@/modules/entities/EntityShortFormModal/CreateEntityShortFormModal';
import { ROUTE_KEYS } from '@/navigation/constants';
import { getCompletePathFromRouteKey } from '@/navigation/navigationUtils';

/** Integration login returns to the client list with this parameter. */
export const PRE_OPEN_ONBOARDING_MODAL_PARAM = 'preOpenOnboardingModal';
export const CONTINUE_ONBOARDING_FLOW_PARAM = 'continueOnboardingFlowFrom';
export const ENTITY_INTAKE_STEP = 'ENTITY_INTAKE';

export function shouldPreopenOnboardingModal(): boolean {
  const params = new URLSearchParams(window.location.search);
  return params.get(PRE_OPEN_ONBOARDING_MODAL_PARAM) === 'true';
}

export interface CreateHouseholdFlowProps {
  isOpen: boolean;
  onClose: () => void;
  continueFrom?: string | null;
  continueFromHouseholdId?: string;
}

/** Continue entity intake, or migrate old creation links to SmartReview. */
export function CreateHouseholdFlow({
  isOpen,
  onClose,
  continueFrom,
  continueFromHouseholdId: householdId,
}: CreateHouseholdFlowProps) {
  const { navigate } = useNavigateToRoute();
  if (!isOpen) return null;

  if (continueFrom !== ENTITY_INTAKE_STEP) {
    return (
      <Navigate
        replace
        to={getCompletePathFromRouteKey(
          ROUTE_KEYS.HOUSEHOLDS_LIST,
          {},
          { [PRE_OPEN_ONBOARDING_MODAL_PARAM]: true }
        )}
      />
    );
  }

  if (!householdId) return null;

  return (
    <CreateEntityShortFormModal
      householdId={householdId}
      isOpen
      onClose={onClose}
      onAfterCreate={() =>
        navigate(ROUTE_KEYS.HOUSEHOLD_ESTATE_TRUSTS, { householdId })
      }
      isOnboardingFlow
    />
  );
}
